import React, { useState, useEffect } from 'react';
import { getBackendURL } from '../utils';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../auth';
import ProgressTabs from '../components/ProgressTabs';
import SweatTextTitle from '../steps/SweatTextTitle';
import RemindersInfo from './RemindersInfo';

import '../BasicReminder.css';

const Step5 = () => {
  const { user } = useAuth();
  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const steps = ['Step 1', 'Step 2', 'Step 3', 'Step 4', 'Step 5', 'Step 6'];

  useEffect(() => {

    if (!user) return;


    if (!user || !user.role.includes('trainer')) {
      alert('You must be a trainer to access this step. If you are indeed a trainer, please contact our Instagram for account support.');
      navigate('/tools/reminders/step1');
      return;
    }

    setActive(user.trainer_info?.sms_reminder_feature_enabled || false);

  }, [user, navigate]);

  
  const toggleSchedule = () => {
    setLoading(true);
    fetch(getBackendURL() + '/trainer_info/' + user.trainer_info.id, {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json',
        'Authorization': `Bearer ${window.localStorage.getItem('ptc_access_token') || ''}`
      },
      body: JSON.stringify({ sms_reminder_feature_enabled: !active }),
    })
      .then((res) => {
        if (!res.ok) throw new Error('Failed to toggle schedule');
        setActive(!active);
        // alert(`Schedule ${!active ? 'activated' : 'deactivated'} successfully!`);
      })
      .catch((err) => console.error('Error toggling schedule:', err))
      .finally(() => setLoading(false));
  };

  return (
    <div className="reminder-container fogged-card">
      <SweatTextTitle />
      <RemindersInfo />


      <ProgressTabs currentStep={4} />

      
      <h2 className="step-title">Step 5: Activate</h2>
      <div style={{ marginBottom: '1rem', 
        fontSize: '1.2rem', display: 'flex', 
        alignItems: 'center', gap: '8px' }}>

        <span
          style={{
            display: 'inline-block',
            width: '14px',
            height: '14px',
            borderRadius: '50%',
            background: active ? '#28a745' : '#ccc',
            border: '1px solid #888',
          }}

          aria-label={active ? 'Active' : 'Inactive'}
        />
        <strong>
          Current Status: {active ? 'Active' : 'Inactive'}
        </strong>
      </div>
      <button
        onClick={toggleSchedule}
        disabled={loading}
        style={{
          fontSize: '1.5rem',
          padding: '1rem 2.5rem',
          background: active ? '#6c757d' : '#28a745',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: loading ? 'not-allowed' : 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        {loading ? 'Processing...' : active ? 'Deactivate Schedule' : 'Activate Schedule'}
      </button>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem' }}>
        <button className="ptc-secondary-button" onClick={() => navigate('/tools/reminders/step4')} style={{ padding: '1rem 2rem', fontSize: '1rem' }}>
          Previous Step
        </button>
        <button className="ptc-button" onClick={() => navigate('/tools/reminders/step6')} style={{ padding: '1rem 2rem', fontSize: '1rem' }}>
          Next Step
        </button>
      </div>
    </div>
  );
};

export default Step5;